export const MAINTENANCE_PAGES_QUERY_KEY = ['maintenancePages']
export const PAGES_QUERY_KEY = ['pages']
